<nb-card accent="success">
  <nb-card-header>
    <div class="d-flex">
      <div class="flex-grow-1 d-flex align-items-center justify-content-center">
        <nb-icon *ngIf="action === 'edit'" icon="edit-outline"></nb-icon>
        <nb-icon *ngIf="action !== 'edit'" icon="plus-outline"></nb-icon>
        <div class="ml-3" i18n>{{ title }}</div>
      </div>
      <button nbButton class="ml-3" (click)="close()">
        <nb-icon icon="close-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>
  <nb-card-body style="min-width: 750px">
    <strong class="text-uppercase" i18n>DRB Item Details</strong>
    <hr />
    <form #sourceItemForm="ngForm">
      <div class="row">
        <div class="col">
          <label i18n>ID<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <div class="input-box">
            <span class="prefix" *ngIf="action === 'create'">{{ prefix() }}</span>
            <input
              id="sourceItemId"
              name="sourceItemId"
              nbInput
              fullWidth
              style="width: 100%"
              [(ngModel)]="sourceItem.id"
              #sourceItemId="ngModel"
              [disabled]="action === 'edit'"
              required
              [pattern]="patternId"
            />
            <span class="sufix" *ngIf="action === 'create'">_dmc</span>
          </div>
          <div *ngIf="sourceItemId.errors?.pattern">
            <p class="error" i18n>ID not valid! ID allows only alphanumeric characters and underscore.</p>
          </div>
        </div>
      </div>
      <br />
      <div class="row">
        <div class="col">
          <label i18n>Location<span style="color: red">*</span>:</label>
        </div>
        <div class="col-9">
          <input
            id="location"
            name="location"
            nbInput
            fullWidth
            placeholder="Location"
            style="width: 100%"
            [(ngModel)]="sourceItem.location"
            #location="ngModel"
            [pattern]="patternLocation"
            required
          />
          <div *ngIf="location.errors?.pattern">
            <p class="error" i18n>Location not valid! Quotes (' ") are not allowed.</p>
          </div>
          <div
            *ngIf="
              type === 'link' && (location.touched || location.dirty) && !sourceItem.location.includes('utm_source=')
            "
          >
            <p class="warning" i18n>Missing "utm_source" query parameter. Will set default value: "app".</p>
          </div>
          <div
            *ngIf="
              type === 'link' && (location.touched || location.dirty) && !sourceItem.location.includes('utm_medium=')
            "
          >
            <p class="warning" i18n>Missing "utm_medium" query parameter. Will set default value: "app".</p>
          </div>
          <div
            *ngIf="
              type === 'link' && (location.touched || location.dirty) && !sourceItem.location.includes('utm_campaign=')
            "
          >
            <p class="warning" i18n>
              Missing optional "utm_campaign" query parameter. You can enter the value in the field below.
            </p>
          </div>
        </div>
      </div>
      <br />
      <div
        class="row"
        *ngIf="
          type === 'link' && (location.touched || location.dirty) && !sourceItem.location.includes('utm_campaign=')
        "
      >
        <div class="col">
          <label i18n>Campaign:</label>
        </div>
        <div class="col-9">
          <input
            id="campaign"
            name="campaign"
            nbInput
            fullWidth
            placeholder="Campaign"
            style="width: 100%"
            [(ngModel)]="sourceItemCampaign"
            #campaign="ngModel"
            [pattern]="patternCampaign"
          />
          <div *ngIf="campaign.errors?.pattern">
            <p class="error" i18n>Only lowercase letters, numbers and underscores are allowed.</p>
          </div>
        </div>
      </div>
      <br />
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="d-flex justify-content-end">
      <button nbButton (click)="close()" i18n>Close</button>
      <button nbButton class="ml-3" status="success" (click)="save()" [disabled]="!sourceItemForm.form.valid" i18n>
        Save
      </button>
    </div>
  </nb-card-footer>
</nb-card>
